import {initializeFileHandler, removeFile} from './shared/uploader_utils';

let allOffenderLicensePhotos = []

window.reloadOffenderLicensePhotoUploader = () => {
  // Target the container where Cocoon inserts nested fields
  const container = document.querySelector('#offender-license-photos-container');

  if (!container) {
    return;
  }

  initializeOffenderLicensePhotoHandler('offender-license-photos', allOffenderLicensePhotos);
  bindOffenderLicensePhotoRemoveEvent(container, allOffenderLicensePhotos);

  // Initialize MutationObserver
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const uploadContainer = node.querySelector('.upload-form.file-upload-area');
          const fileField = node.querySelector('input[type="file"]');
          // const previewsContainer = node.querySelector('.file-previews');
          const previewsContainer = document.querySelector('[data-preview=offender-license-photos-preview]');

          if (uploadContainer && fileField && previewsContainer) {
            // Small delay to ensure DOM is ready
            setTimeout(function() {
              initializeFileHandler(uploadContainer, fileField, previewsContainer, allOffenderLicensePhotos);
            }, 100);
          }
        }
      });
    });
  });

  // Start observing the container for child additions
  observer.observe(container, { childList: true, subtree: true });
}

function initializeOffenderLicensePhotoHandler(attachmentName, selectionList) {
  const container = document.querySelector(`#${attachmentName}-container`);
  // Initialize handlers for existing permit file fields
  const permitFileForms = container.querySelectorAll('.nested-fields.form-card');
  
  permitFileForms.forEach(function(form) {
    const uploadContainer = form.querySelector('.upload-form.file-upload-area');
    const fileField = form.querySelector('input[type="file"]');
    // const previewsContainer = form.querySelector('.file-previews');
    const previewsContainer = container.querySelector(`[data-preview=${attachmentName}-preview]`);
    
    if (uploadContainer && fileField && previewsContainer) {
      initializeFileHandler(uploadContainer, fileField, previewsContainer, selectionList);
    }
  });
}

function bindOffenderLicensePhotoRemoveEvent(container, selectionList) {
  container.querySelectorAll('.file-preview').forEach(filePreview => {
    filePreview.addEventListener('click', (e) => removeFile(e, selectionList));
  })
}

document.addEventListener('turbolinks:load', function() {
  reloadOffenderLicensePhotoUploader();
});
